import classNames from "clsx";
import { HtmlHTMLAttributes } from "react";
import styles from "./TaskLabel.module.scss";

export type TaskLabelVariant = "primary" | "secondary";

export type TaskLabelProps = {
    /**
     * Determines the style of the task label
     * @default primary
     */
    variant?: TaskLabelVariant;

    /**
     * Determines the color of the task label
     * @default alert
     */
    status: "alert" | "success";

    /**
     * Task label text
     */
    text?: string;
    /**
     *
     */
    className?: string;
} & HtmlHTMLAttributes<HTMLSpanElement>;

export const TaskLabel: React.FC<TaskLabelProps> = ({
    variant = "primary",
    status = "alert",
    text,
    className,
    ...spanProps
}) => {
    const taskLabelClassName = classNames(
        styles["task-label"],
        styles[`${variant}--${status}`],
        className,
    );
    return (
        <span {...spanProps} className={taskLabelClassName}>
            {text}
        </span>
    );
};
